import { createApp, defineAsyncComponent } from 'vue';
import { createPinia } from 'pinia'

const app = createApp();
const pinia = createPinia();

app.use(pinia);

app.config.compilerOptions.nativeTemplate = false;
app.config.compilerOptions.whitespace = 'preserve';

// Define asynchronous components
const asyncComponents = {
    SiteHeader: defineAsyncComponent(() => import(/* webpackPrefetch: true, webpackChunkName: 'SiteHeader' */ './components/SiteHeader.vue')),
    BlogList: defineAsyncComponent(() => import(/* webpackChunkName: 'BlogList' */ './components/BlogList.vue')),
    AccordionItem: defineAsyncComponent(() => import(/* webpackChunkName: 'AccordionItem' */ './components/AccordionItem.vue')),
    TypeWriter: defineAsyncComponent(() => import(/* webpackChunkName: 'TypeWriter' */ './components/TypeWriter.vue')),
    FadeCarousel: defineAsyncComponent(() => import(/* webpackChunkName: 'FadeCarousel' */ './components/FadeCarousel.vue')),
    // ProgressBar: defineAsyncComponent(() => import(/* webpackChunkName: 'ProgressBar' */ './components/ProgressBar.vue')),
    // DynamicModalButton: defineAsyncComponent(() => import(/* webpackChunkName: 'DynamicModalButton' */ './components/DynamicModalButton.vue')),
    // SearchResults: defineAsyncComponent(() => import(/* webpackChunkName: 'SearchResults' */ './components/SearchResults.vue')),
    // TruncatedText: defineAsyncComponent(() => import(/* webpackChunkName: 'TruncatedText' */ './components/TruncatedText.vue')),
    // HeroCarousel: defineAsyncComponent(() => import(/* webpackChunkName: 'HeroCarousel' */ './components/HeroCarousel.vue')),
    // ModalButton: defineAsyncComponent(() => import(/* webpackChunkName: 'ModalButton' */ './components/ModalButton.vue')),
    // TabsWrapper: defineAsyncComponent(() => import(/* webpackChunkName: 'TabsWrapper' */ './components/TabsWrapper.vue')),
    // Tab: defineAsyncComponent(() => import(/* webpackChunkName: 'Tab' */ './components/Tab.vue')),
    ImageComparisonSlider: defineAsyncComponent(() => import(/* webpackChunkName: 'ImageComparisonSlider' */ './components/ImageComparisonSlider.vue')),
    SocialShare: defineAsyncComponent(() => import(/* webpackChunkName: 'SocialShare' */ './components/SocialShare.vue')),
    // ProductGallery: defineAsyncComponent(() => import(/* webpackChunkName: 'ProductGallery' */ './components/ProductGallery.vue')),
    // ProductCardCarousel: defineAsyncComponent(() => import(/* webpackChunkName: 'ProductCardCarousel' */ './components/ProductCardCarousel.vue')),
    // AddToBasketModalButton: defineAsyncComponent(() => import(/* webpackChunkName: 'AddToBasketModalButton' */ './components/commerce/AddToBasketModalButton.vue')),
    // NumberCounter: defineAsyncComponent(() => import(/* webpackChunkName: 'NumberCounter' */ './components/NumberCounter.vue')),
    // CognitoForm: defineAsyncComponent(() => import(/* webpackChunkName: 'CognitoForm' */ './components/CognitoForm.vue')),
    // SearchModalButton: defineAsyncComponent(() => import(/* webpackChunkName: 'SearchModalButton' */ './components/SearchModalButton.vue')),
    // LottieAnimation: defineAsyncComponent(() => import(/* webpackChunkName: 'LottieAnimation' */ './components/LottieAnimation.vue')),
};

// Register components asynchronously
for (const [componentName, asyncComponent] of Object.entries(asyncComponents)) {
    app.component(componentName, asyncComponent);
}

app.mount('#app');